<template>
  <div class="agreement-container">
    <h2>STANDARD TERMS AND CONDITIONS FOR SOLAR POWER SYSTEM SERVICES</h2>
    <div class="terms-and-condition" v-if="agreementCount">
      <div>
        <p>
          These standard terms and conditions apply to services rendered by
          Arnergy Solar Limited (“Arnergy”) to a customer (the “Customer”)
          pursuant to a contractual agreement recording the terms of the
          engagement (the “Contract”) incorporating these standard terms and
          conditions by reference.
          <br />
          <h2>1. DEFINITIONS</h2>
          <br />
          1.1. Business Day means means a day (other than a Saturday, Sunday or
          public holiday) when banks in Lagos, Nigeria are open for general
          business;
          <br />
          1.2. Delivery Date means the date of installation of the System by
          Arnergy at the Location;
          <br />
          1.3. Location means the agreed site of the Customer where a System is
          installed;
          <br />
          1.4. Services means the provision of the solar power system services
          to the Customer; and
          <br />
          1.5. System means the solar power systems, including the solar
          modules/panels, inverter system, battery storage, remote monitoring
          technology and other accessories deployed by Arnergy.
          <br />
          1.6 If there is conflict between this Standard Terms and Conditions
          and the Contract, the Standard Terms and Conditions, will prevail.
          <br />
          <h2>2. OWNERSHIP OF THE SYSTEM</h2>
          <br />
          <br />
          The customer acknowledges that the System provided and installed at
          the Location will remain the personal property of Arnergy and will
          continue in the ownership of Arnergy for the duration of the Contract.
          <br />
          <h2>3. RISK, DELIVERY AND INSTALLATION OF THE SYSTEM</h2>
          <br />
          <br />
          3.1. Arnergy shall be responsible for the delivery of the System to
          the Location and the installation, commissioning and testing of the
          System.
          <br />
          3.2. The customer acknowledges that the risk of loss, theft, damage,
          or destruction to the System shall pass to the Customer upon delivery
          and installation of the System at the Location.
          <br />
          3.3. The delivery of the System, and acceptance by the Customer, is
          deemed to take place on the Delivery Date. Upon the completion of the
          delivery and installation of the System, the Customer shall present
          Arnergy with an executed copy of the Certificate of Acceptance and by
          doing so, the Customer will be deemed to have acknowledged delivery
          of, and unconditionally accepted the System.
          <br />
          3.4. Arnergy shall offer appropriate training to onboard the Customer
          on the use of the System after the completion of delivery and
          installation of the System.
          <br />
          3.5. On completion of the installation of the System, Arnergy shall
          remove any unused materials and debris generated during installation
          from the deployment address at its own cost within two (2) days from
          the date of completion of installation failing which the Customer may
          proceed with the removal of such debris and Arnergy shall make a full
          refund of the cost expended in effecting the removal.
          <br />
          <h2>4. PAYMENTS</h2>
          <br />
          <br />
          4.1. Arnergy’s fees shall be as agreed in the Contract.
          <br />
          4.2. We shall invoice the Customer for payments at the beginning of
          each month for the Services to be provided during that month. 4.3. We
          may review the monthly payments subject to prevailing market
          conditions. Arnergy shall promptly notify the Customer in such
          instances.
          <br />
          4.4. Arnergy’s monthly payments shall be payable by the Customer,
          regardless of whether the solar power was used or unused. 4.5. The
          Customer acknowledges that where payments fall due on a day which is
          not a Business Day, such payments are to be made on the preceding
          Business Day.
          <br />
          4.6. Payments made by the Customer to Arnergy must be without any set
          off or counterclaim and free and clear of all deductions or
          withholdings whatsoever save only as may be required by law, in which
          event the Customer shall pay to Arnergy such additional amount as may
          be necessary in order that the net amount received by Arnergy after
          deductions and withholdings will not be less than the amount Arnergy
          would have been entitled to receive in the absence of any requirement
          to make any deduction or withholding.
          <br />
          4.7. In the event of non- payment by a Customer where the requisite
          time frame for payment (five (5) days from the date of receipt of the
          relevant invoice by the Customer) has lapsed, the Customer
          acknowledges that Arnergy may charge interest which shall accrue each
          day at the rate of [20%] per annum above the 30-day NIBOR (published
          by FMDQ OTC on the due date) from the due date until the outstanding
          payments are processed by the Customer.
          <br />
          4.8. Should the Customer fail to effect timeous payment of the amount
          payable, Arnergy may (without prejudice to other rights and remedies
          of Arnergy) suspend part or all of the Services until payment has been
          made in full.
          <br />
          <h2>5. MONITORING OF THE SYSTEM, ELECTRICITY OVERLOAD AND SYSTEM REPAIRS</h2>
          <br />
          5.1. Arnergy and the Customer shall have access to round the clock
          technology to monitor the System. This shall be at no additional cost
          to the Customer.
          <br />
          5.2. Arnergy shall conduct routine maintenance of the System regularly
          and corrective maintenance where required. 5.3. The Customer
          authorises Arnergy and its designated personnel to have access to
          inspect the System where Arnergy has provided 12 hours prior notice to
          the Customer by SMS or email ahead of routine maintenance inspections
          (between the hours of 9.00am-5.00pm).
          <br />
          5.4. Where the Customer effects an increase on the amount of
          electricity required at the Location contrary to the agreed actual
          load without prior notice to Arnergy, such an increase/extra load
          shall be prorated based on the monthly charges payable by the
          Customer.
          <br />
          5.5. Arnergy shall maintain and repair the System at no additional
          cost to the Customer, unless the damage to the System was caused by
          negligence or willful misconduct of the Customer and/or its
          affiliates, in which case, the Customer shall bear the cost for repair
          and replacing all worn and damaged parts of the System.
          <br />
          5.6. Only authorised personnel of Arnergy are permitted to repair the
          System.
          <br />
          <h2>6. MAINTENANCE AND WARRANTY COVER</h2>
          <br />
          <br />
          6.1 Where any corrective maintenance is required within working hours,
          it shall be done within twenty-four (24) hours of Arnergy’s awareness
          of such corrective maintenance or repair. Provided that, where
          corrective maintenance is reported after 5pm on a business day, it
          shall be done within twenty-four (24) hours from start of business on
          the next business day.
          <br />
          <br />
          6.2 Arnergy warrants that the System, described in schedule 1 of the
          Contract is free from defects in materials and workmanship for a
          period of Seven (7) years from the Effective Date. This warranty shall
          not apply to an abuse, damage, alteration or misuse of the System by
          the gross negligence or willful misconduct of the Customer. Arnergy
          shall not be liable to the Customer, whether in contract, tort
          (including negligence), breach of statutory duty, or otherwise, for
          any loss of profit, or for any indirect or consequential loss arising
          under or in connection with the Contract or the Customer’s use of the
          System.
          <br />
          <br />
          <h2>7. DEFAULT AND ACCESS TO DECOMMISSION THE SYSTEM</h2>
          <br />
          <br />
          7.1. In the event of any willful or negligent damage to the System, or
          consistent two (2) months failure to make payments due to Arnergy, the
          Customer acknowledges that the caution fee shall be applied for the
          month of default for a maximum period of two (2) months.
          <br />
          7.2. The Customer acknowledges that Arnergy shall be entitled to
          decommission the System from the Location in the below instances:
          <br />
          7.2.1. Willful or negligent damage to the System by the Customer/and
          or its affiliates and the Customer is reluctant to bear responsibility
          for repairs;
          <br />
          7.2.2. Default in monthly payments for three (3) months; or
          <br />
          7.2.3. Complete abandonment of the System.
          <br />
          7.3. The Customer authorises Arnergy and its designated personnel to
          have access to decommission the System where Arnergy has provided 12
          hours prior notice to the Customer by SMS or email ahead of routine
          maintenance inspections (between the hours of 9.00am-5.00pm).
          <br />
          7.4. Where Arnergy is unable to take possession of the System, the
          Customers shall be liable to pay to Arnergy N500,000.00 as default
          rate for each day which the Customer remains in possession of the
          System. Until the System has been returned or repossessed, the
          Customer shall be solely responsible for its safe keeping.
          <br />
          <h2>8. SWITCH TO ALTERNATIVE BUSINESS MODEL AND SYSTEM UPGRADE</h2>
          <br />
          <br />
          8.1. Subject to Arnergy’s consent, the Customer may opt to switch to
          an alternative business model of Arnergy. In such cases, any necessary
          amendments to the engagement with the Customer shall be forward
          looking and shall have no bearing on payments already made by the
          Customer for services rendered in previous months.
          <br />
          8.2. Subject to Arnergy’s consent, the Customer may also opt to
          upgrade to a higher System, and Arnergy will review such request
          provided the Customer has consistently paid the monthly charges for a
          period of not less than twelve (12) months prior to the date of the
          Customer’s request for an upgrade. The Customer may be required to pay
          the difference in the set up fee earlier made and the current set up
          fee for the upgraded System. The Customer may also opt to downgrade
          the System and Arnergy will review such request provided the Customer
          has consistently paid the monthly charges for a period of not less
          than six (6) months prior to the date of the Customer’s request for a
          downgrade.
          <br />
          <h2>9. DISPOSAL OF SYSTEM</h2>
          <br />
          <br />
          9.1. Where the Customer has possession of a System under an agreement
          with Arnergy, and wishes to dispose of the System having purchased the
          System, the Customer is required to comply with Arnergy's recommended
          disposal procedure, and failure to comply with the recommended
          disposal procedure, shall not make Arnergy liable.
          <br />
          <br />
          9.2. The System is considered an electronic device for disposal in
          accordance with Nigerian laws and may not be disposed of as domestic
          waste. Therefore:
          <br />
          ● Customer shall use only designated channels for disposing the
          devices;
          <br />
          ● Customer shall comply with all local and currently applicable laws
          and regulations.
          <br />
        </p>
      </div>
    </div>
    <div class="below-agreement">
      <div class="accept-terms" @click="toggleAgreementCheck">
        <span class="green-box">
          <svg
            v-if="checkAgreement"
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.7586 2.00489C13.0804 2.34979 13.0804 2.89737 12.7586 3.24227L5.52359 10.9952C5.33629 11.196 5.07182 11.2919 4.80879 11.2611C4.56725 11.2703 4.33131 11.1737 4.16035 10.9905L0.241389 6.79096C-0.0804629 6.44606 -0.0804629 5.89847 0.241389 5.55358C0.579197 5.19159 1.14011 5.19159 1.47791 5.55357L4.8441 9.16052L11.5221 2.00489C11.8599 1.6429 12.4208 1.6429 12.7586 2.00489Z"
              fill="white"
            />
          </svg>
        </span>
        <small>Click to Accept Terms and Regulations</small>
      </div>
      <div class="terms-pagination">
        <div
          class="button left-btn"
          @click="handleAgreementNavigation('minus')"
        >
          <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.95213 7.872L0.384125 4.256L3.95213 0.655999H6.54413L2.94413 4.256L6.54413 7.872H3.95213Z"
              fill="#0892D0"
            />
          </svg>
        </div>
        <div
          class="button right-btn"
          @click="handleAgreementNavigation('plus')"
        >
          <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.448125 7.872L4.03212 4.256L0.448125 0.655999H3.02413L6.60813 4.256L3.02413 7.872H0.448125Z"
              fill="#0892D0"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LOAgreement",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  data() {
    return {
      checkAgreement: false,
      agreementCount: 1
    };
  },
  methods: {
    toggleAgreementCheck() {
      this.checkAgreement = !this.checkAgreement;
      this.markAsCompleted(this.checkAgreement);
    },
    handleAgreementNavigation(direction) {
      if (this.agreementCount >= 0) {
        if (direction === "plus") this.agreementCount = this.agreementCount + 1;
        if (direction === "minus")
          this.agreementCount = this.agreementCount - 1;
      }
    }
  },
  mounted() {
    this.updateTracker(true);
    this.updateStatus(3);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

* {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  line-height: 1.5;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  margin-top: 14px;
  margin-block: 5px;
  font-weight: 700;
}

.agreement-container {
  display: flex;
  flex-direction: column;
}

.terms-and-condition,
.terms-pagination,
.below-agreement {
  display: flex;
}

.terms-and-condition {
  justify-content: space-between;
  height: 56vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  > div {
    width: 52%;
    height: 47.5vh;
    /* margin-right: 4rem; */

    p {
      margin-right: 5rem;
    }
  }

  .main-title {
    color: #000000;
  }

  .sub-sub-title {
    text-indent: 20px;
  }

  .column1 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.green-box {
  width: 20px;
  height: 20px;
  background: #4aeb76;
}

.accept-terms {
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  small {
    color: #727272;
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
    display: inline-block;
    margin-left: 12px;
  }
}

.below-agreement {
  justify-content: space-between;
  align-items: center;
}

.terms-pagination .button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
  cursor: pointer;

  &:first-child {
    margin-right: 5px;
  }
}

.top-level {
  margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/LOAgreement.vue